'use client';

import { ReactNode, useEffect } from 'react';

import { createPortal } from 'react-dom';

import { CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import useBodyScrollLock from '@hooks/useBodyScrollLock';

import {
  MobileModalBody,
  MobileModalCloseButton,
  MobileModalHeader,
  MobileModalSurface,
  MobileModalTitle,
} from './styled';

interface PackageTemplateMobileModalProps {
  children: ReactNode;
  isOpen: boolean;
  title: string;
  onClose: () => void;
}

const PackageTemplateMobileModal = ({
  children,
  isOpen,
  title,
  onClose,
}: PackageTemplateMobileModalProps) => {
  useBodyScrollLock(isOpen);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || typeof document === 'undefined') return null;

  return createPortal(
    <MobileModalSurface
      role='dialog'
      aria-modal='true'
      aria-labelledby='package-template-mobile-modal-title'
    >
      <MobileModalHeader>
        <MobileModalCloseButton
          type='button'
          aria-label={`${title} penceresini kapat`}
          onClick={onClose}
          autoFocus
        >
          <CustomIcon
            icon={CloseIcon}
            width={24}
            height={24}
            paletteColor='grey1100'
          />
        </MobileModalCloseButton>
        <MobileModalTitle id='package-template-mobile-modal-title'>
          {title}
        </MobileModalTitle>
      </MobileModalHeader>
      <MobileModalBody>{children}</MobileModalBody>
    </MobileModalSurface>,
    document.body
  );
};

export default PackageTemplateMobileModal;
